import React, { FC } from 'react';
import styles from './_styles.module.scss';

const JobDetailsMobContainer: FC = ({ children }) => {
  return <div className={styles.view_job_mob_wrap}>{children}</div>;
};

export default JobDetailsMobContainer;
